import useStyles from "../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import { Grid } from '@mui/material';
import EAButton from '../../common/EAButton';
import { PrivilegeEnum } from '../../../services/common/RolesUtils';
import EAIcon from '../../common/EAIcon';
import i18next from 'i18next';
import React, { useCallback, useContext, useState } from 'react';
import { getAuditTrail } from '../../../services/edge/EventsService';
import { ERROR } from '../../../services/common/Constants';
import { Context } from '../../../states/Store';
import { reactivateThirdparty } from "services/edge/ThirdpartyService.js";
import { useHistory } from "react-router";
import EAColorIcon from "components/common/EAColorIcon.js";

function ArchiveAndAuditPistButton({
                                     thirdparty,
                                     tpId,
                                     hasAnyOfPrivilegesOnScopedResource,
                                     setIsStopDialogOpen}) {
  const { classes } = useStyles();
  const [state, dispatch] = useContext(Context);
  const [downloadingAudit, setDownloadingAudit] = useState(false);

  const history = useHistory();

  const downloadAuditTrail = useCallback(() => {
    if (state.account) {

      (async function fetchData() {
        try {
          setDownloadingAudit(true);

          const resp = await getAuditTrail(
            state.account.id,
            thirdparty.thirdpartyId,
            null,
            null,
            state.lang,
            dispatch
          );

          // download the file from the returned link
          const link = document.createElement("a");
          link.href = resp.content?.slice(1, -1);
          link.style.display = "none";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setDownloadingAudit(false);
        } catch (e) {
          if (!e?.message.messages?.error) {
            dispatch({
              type: "ALERT",
              alert: { type: ERROR, msg: "INTERNAL_ERROR" },
            });
          }
          setDownloadingAudit(false);
        }
      })();
    }
    // eslint-disable-next-line
  }, [thirdparty, dispatch, state.account]);

        const onReactivateThirdparty = useCallback(async (thirdpartyId) => {
      try {
        await reactivateThirdparty(
          state.account.id,
          thirdpartyId,
          dispatch
        );
        history.go(0);
      } catch (error) {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "REACTIVATE_THIRDPARTY_ERROR" },
        });
      }
    },[state.account.id, dispatch, history]);

  return (
    <Grid container item xs={tpId ? 4 : 4}
          style={{
            position: tpId ? "fixed" : "absolute",
            top: tpId ? "14px" : "",
            right: tpId ? "155px" : "50px",
            zIndex: 999,
          }}
    >
      <Grid item xs={12}>
          <Grid
            container
            item
            xs={12}
            justifyContent="flex-end"
            gap={2}
          >
            {/* Archive button */}
            {thirdparty.onboarded ? (
              <EAButton
                colorVariant="secondary_dark"
                disabled={
                  !hasAnyOfPrivilegesOnScopedResource(
                    PrivilegeEnum.PRIVILEGE_ARCHIVE_THIRD_PARTY
                  )
                }
                onClick={() => setIsStopDialogOpen(true)}
                customStyle={{
                  height: '42px',
                  boxShadow:
                    '0px 11.28px 24.231px rgba(154, 154, 175, 0.115017), 0px 6.0308px 12.9551px rgba(154, 154, 175, 0.0953772), 0px 3.38082px 7.2625px rgba(154, 154, 175, 0.08), 0px 1.79553px 3.85706px rgba(154, 154, 175, 0.0646228), 0px 0.747159px 1.60501px rgba(154, 154, 175, 0.0449833)',
                }}
                content={
                  <>
                    <EAIcon
                      icon={'archive_grey'}
                      className={classes.archiveButtonIon}
                    />
                    {i18next.t('archive')}
                  </>
                }
              />

            ) : (
              <EAButton
                colorVariant={"primaryLight"}
                customStyle={{ color: "#656575", boxShadow: "none" }}
                content={
                  <>
                    <EAColorIcon icon={"play_circle_filled_green"} svgStyle={{ marginRight: "4px" }} />
                    <span>{i18next.t("reactivate")}</span>
                  </>
                }
                onClick={() => onReactivateThirdparty(thirdparty.thirdpartyId)}
                disabled={
                  !hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_CREATE_THIRD_PARTY)
                }
              />
            )}
            {/* Audit trail button */}
            <EAButton
              colorVariant="secondary_dark"
              disabled={
                !hasAnyOfPrivilegesOnScopedResource(
                  PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_AUDIT_TRAIL
                ) || downloadingAudit
              }
              onClick={() => downloadAuditTrail()}
              customStyle={{
                height: '42px',
                boxShadow:
                  '0px 11.28px 24.231px rgba(154, 154, 175, 0.115017), 0px 6.0308px 12.9551px rgba(154, 154, 175, 0.0953772), 0px 3.38082px 7.2625px rgba(154, 154, 175, 0.08), 0px 1.79553px 3.85706px rgba(154, 154, 175, 0.0646228), 0px 0.747159px 1.60501px rgba(154, 154, 175, 0.0449833)',
                cursor: downloadingAudit ? 'wait' : 'pointer',
              }}
              content={
                <>
                  <EAIcon
                    icon={'audit-trail-thirdparty_grey'}
                    className={classes.archiveButtonIon}
                  />
                  {i18next.t('downloadAuditTrail')}
                </>
              }
            />
          </Grid>
      </Grid>
    </Grid>
  );
}

export default ArchiveAndAuditPistButton;
